import { cn } from 'noddi-ui-common';
import { NoddiEmptyContent } from './NoddiEmptyContent';
import type { NoddiEmptyProps } from './types';

type Props = NoddiEmptyProps & {
  className?: string;
};

export const NoddiEmptyPage = ({ message, title, children, emptyIcon, className }: Props) => {
  return (
    <div className={cn('mx-auto flex min-h-[40vh] items-center justify-center', className)}>
      <NoddiEmptyContent message={message} title={title} emptyIcon={emptyIcon}>
        {children}
      </NoddiEmptyContent>
    </div>
  );
};
